import { render } from "./miniCriterios.vue?vue&type=template&id=1314801e&scoped=true"
import script from "./miniCriterios.vue?vue&type=script&lang=js"
export * from "./miniCriterios.vue?vue&type=script&lang=js"

import "./miniCriterios.vue?vue&type=style&index=0&id=1314801e&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1314801e"]])

export default __exports__